// src/utils/promotion.js

export const getEligiblePromotionTickets = (saleTotal, promotions) => {
    const today = new Date();
  
    // Filter promotions active today
    const activePromos = promotions.filter((promo) => {
      const start = new Date(promo.start_date);
      const end = new Date(promo.end_date);
      return today >= start && today <= end;
    });
  
    if (activePromos.length === 0) return 0;
  
    // Choose the highest applicable threshold
    const eligibleThresholds = activePromos
      .map((p) => p.threshold)
      .filter((t) => saleTotal >= t);
  
    if (eligibleThresholds.length === 0) return 0;
  
    const bestThreshold = Math.max(...eligibleThresholds);
    return Math.floor(saleTotal / bestThreshold);
  };
  